import {Component, Input, OnInit} from '@angular/core';
import {UpsertAlertNote} from "@flowmaps-com/flowmaps-typescriptmodels";
import {View} from "../../../common/view";

@Component({
  selector: 'app-alert-note-details',
  templateUrl: './alert-note-details.component.html',
  styleUrls: ['./alert-note-details.component.css']
})
export class AlertNoteDetailsComponent extends View implements OnInit {
  @Input() data;
  note: string;

  ngOnInit(): void {
    this.note = this.data.note || ""
  }

  updateNote = () => {
    return this.sendCommand("com.flowmaps.api.monitoring.alerting.UpsertAlertNote", <UpsertAlertNote> {
      alertId: this.data.alert.alertId,
      note: this.note,
    });
  };
}
